import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _Absenteeism, _AnnotationReport } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectTHConstantsValue } from "../../../bpm/config/Componentes/SelectTHConstantsValue";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { FileInput } from "../../../theme/Component/FileInput";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectStateConst } from "../../GestionTH/PaymentAccount/SelectStateConst";
import { BasicButton } from "../../../theme/Component/BasicButton";
import usePaginator from "../../../theme/Component/usePaginator";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../contract/select/SelectMonths";
import { DropDown } from "../../../theme/Component/DropDown";
import useModal, { MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";


export const Absenteeism = () => {

    const absenteeism = useDataBean(_Absenteeism);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const paginador = usePaginator();
    const [data, setData] = useState<any>({
        FromYear: _single.getCurrenYear()
    });
    // const [state, setstate] = useState<any>(null);
    // const [year, setyear] = useState<any>(_single.getCurrenYear())
    // const [month, setMonth] = useState<any>(null)
    // const [Account, setAccount] = useState<any>(null)
    // const [regexStr, setregexStr] = useState<string>(null)
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalAdd, setModalAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [])



    const getLista = () => {
        let filter = _single.cleanMap(data);
        absenteeism.instance.getAbsenteeismCatalogByPropertiesRender(paginador.page, 15, filter).then((resp: any) => {
            if (resp && resp.NumberOfPages) {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                paginador.setRegiPerPage(15);
            }
            if (Array.isArray(resp?.List)) {
                resp.List.forEach((item) => {
                    item.DataBeanProperties.HoraInicio = (item.DataBeanProperties.HourFrom ?? "") + " : " + (item.DataBeanProperties.MinuteFrom ?? "");
                    item.DataBeanProperties.HoraFinal = (item.DataBeanProperties.HourUpto ?? "") + " : " + (item.DataBeanProperties.MinuteUpto ?? "");
                });

                setLista(resp.List);
            } else {
                setLista([]);
            }
        });
    };



    const create = () => {
        absenteeism.setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),

        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        absenteeism.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                setModalAdd({ ...modalAdd, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        absenteeism.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDAbsenteeism', visible: true },
        { title: 'Funcionario', property: 'AccountName', visible: true },
        { title: 'Identificación', property: 'NitAccount', visible: true, },
        { title: 'Tipo Ausentismo', property: 'TypeAbsenteeismName', visible: true },
        { title: 'Desde', property: 'FromDate', visible: true },
        { title: 'Hora de Inicio', property: 'HoraInicio', visible: true },
        { title: 'Hasta', property: 'UpdoDate', visible: true },
        { title: 'Hora de Finalización', property: 'HoraFinal', visible: true },
        { title: 'Descripcion del ausentismo', property: 'Descripcion', visible: true },
        { title: 'Quien realiza', property: 'EmployeeName', visible: true },
        { title: 'Fecha de Modificación', property: 'Since', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Adjuntos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalAdd({ ...modalAdd, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const modalCSV = useModal("Exportar información", MODAL_SM);

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }

                </div>
            </div>
        )
    }

    const actions = (e: any) => {

        if (e.id === 1) {
            getListaExport();
            modalCSV.open();
        }
    }

    const [listaExport, setListaExport] = useState([]);

    const getListaExport = () => {
        let filter = _single.cleanMap(data);
        absenteeism.instance.getAbsenteeismCatalogByPropertiesRender(1, paginador.pages * 15, filter).then(
            (resp: any) => {
                resp.List.forEach((item) => {
                    item.DataBeanProperties.HoraInicio = (item.DataBeanProperties.HourFrom ?? "") + " : " + (item.DataBeanProperties.MinuteFrom ?? "");
                    item.DataBeanProperties.HoraFinal = (item.DataBeanProperties.HourUpto ?? "") + " : " + (item.DataBeanProperties.MinuteUpto ?? "");
                });
                setListaExport(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        );
    }

    return (
        <BasicPage titulo="Personal Ausente">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector value={data.FromYear} onChange={(e) => { setData({ ...data, "FromYear": e }) }} />
                </div>
                <div className="col-md-4">
                    <SelectMonths idSelector={data.FromMonth} onChange={(e: any) => { setData({ ...data, "FromMonth": e }) }}></SelectMonths>
                </div>
                <div className="col-md-4">
                    <AccountEditor label="Tercero" idAccount={data.IDAccount} onChange={(e) => { setData({ ...data, "IDAccount": e.IDAccount }) }}></AccountEditor>
                </div>
                <div className="col-md-4">
                    <label>Estado</label>
                    <select className="form-control" value={data.State} onChange={(e: any) => { setData({ ...data, "State": e.target.value }) }} >
                        <option value={NaN}>...</option>
                        <option value={1}>ACTIVO</option>
                        <option value={2}>BORRADO</option>
                    </select>
                </div>
                <div className="col-md-4">

                    <label>Búsqueda por Numero Identificación</label>
                    <input type="text" name="Name" className="form-control" value={data.NitAccount} onChange={(e: any) => { setData({ ...data, "NitAccount": e.target.value }) }} />
                </div>

                <div className="col-md-4 mt-3 p-2">
                    <BasicButton eventClick={getLista} icon="ri-folder-upload-fill p-2" >
                        Buscar por Filtros
                    </BasicButton>
                </div>
                <div className="col-md-12">

                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={absenteeism.setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        next={paginador.next}
                        pageTop={paginador.page}
                        back={paginador.back}
                        records={paginador}
                        headButtons={buttons()}
                    />
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <AccountEditor label="Funcionario" idAccount={absenteeism.bean.IDAccount} onChange={(e) => { absenteeism.setBean({ ...absenteeism.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>
                                <div className="col-md-6">
                                    <label>Tipo Ausentismo</label>
                                    <SelectTHConstantsValue code={211} value={absenteeism.bean.TypeAbsenteeism} onChange={(e: any) => { absenteeism.setBean({ ...absenteeism.bean, "TypeAbsenteeism": e }) }}></SelectTHConstantsValue>
                                </div>
                                <div className="col-md-6">
                                    <InputDate notDate label="Desde" name="FromDate" value={absenteeism.bean.FromDate} setDate={(e) => { absenteeism.setBean({ ...absenteeism.bean, "FromDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Hora de Inicio</label>
                                    <div className="row">
                                        <div className="col-md-5">

                                            <select className="form-control" value={absenteeism.bean.HourFrom} onChange={(e) => { absenteeism.setBean({ ...absenteeism.bean, 'HourFrom': parseInt(e.target.value) }) }}>
                                                <option value={NaN}>...</option>
                                                <option value={0}>00</option>
                                                <option value={1}>01</option>
                                                <option value={2}>02</option>
                                                <option value={3}>03</option>
                                                <option value={4}>04</option>
                                                <option value={5}>05</option>
                                                <option value={6}>06</option>
                                                <option value={7}>07</option>
                                                <option value={8}>08</option>
                                                <option value={9}>09</option>
                                                <option value={10}>10</option>
                                                <option value={11}>11</option>
                                                <option value={12}>12</option>
                                                <option value={13}>13</option>
                                                <option value={14}>14</option>
                                                <option value={15}>15</option>
                                                <option value={16}>16</option>
                                                <option value={17}>17</option>
                                                <option value={18}>18</option>
                                                <option value={19}>19</option>
                                                <option value={20}>20</option>
                                                <option value={21}>21</option>
                                                <option value={22}>22</option>
                                                <option value={23}>23</option>

                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            :
                                        </div>
                                        <div className="col-md-5">

                                            <select className="form-control" value={absenteeism.bean.MinuteFrom} onChange={(e) => { absenteeism.setBean({ ...absenteeism.bean, 'MinuteFrom': parseInt(e.target.value) }) }}>
                                                <option value={NaN}>...</option>
                                                <option value={0}>00</option>
                                                <option value={1}>01</option>
                                                <option value={2}>02</option>
                                                <option value={3}>03</option>
                                                <option value={4}>04</option>
                                                <option value={5}>05</option>
                                                <option value={6}>06</option>
                                                <option value={7}>07</option>
                                                <option value={8}>08</option>
                                                <option value={9}>09</option>
                                                <option value={10}>10</option>
                                                <option value={11}>11</option>
                                                <option value={12}>12</option>
                                                <option value={13}>13</option>
                                                <option value={14}>14</option>
                                                <option value={15}>15</option>
                                                <option value={16}>16</option>
                                                <option value={17}>17</option>
                                                <option value={18}>18</option>
                                                <option value={19}>19</option>
                                                <option value={20}>20</option>
                                                <option value={21}>21</option>
                                                <option value={22}>22</option>
                                                <option value={23}>23</option>
                                                <option value={24}>24</option>
                                                <option value={25}>25</option>
                                                <option value={26}>26</option>
                                                <option value={27}>27</option>
                                                <option value={28}>28</option>
                                                <option value={29}>29</option>
                                                <option value={30}>30</option>
                                                <option value={31}>31</option>
                                                <option value={32}>32</option>
                                                <option value={33}>33</option>
                                                <option value={34}>34</option>
                                                <option value={35}>35</option>
                                                <option value={36}>36</option>
                                                <option value={37}>37</option>
                                                <option value={38}>38</option>
                                                <option value={39}>39</option>
                                                <option value={40}>40</option>
                                                <option value={41}>41</option>
                                                <option value={42}>42</option>
                                                <option value={43}>43</option>
                                                <option value={44}>44</option>
                                                <option value={45}>45</option>
                                                <option value={46}>46</option>
                                                <option value={47}>47</option>
                                                <option value={48}>48</option>
                                                <option value={49}>49</option>
                                                <option value={50}>50</option>
                                                <option value={51}>51</option>
                                                <option value={52}>52</option>
                                                <option value={53}>53</option>
                                                <option value={54}>54</option>
                                                <option value={55}>55</option>
                                                <option value={56}>56</option>
                                                <option value={57}>57</option>
                                                <option value={58}>58</option>
                                                <option value={59}>59</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <InputDate notDate label="Hasta" name="UpdoDate" value={absenteeism.bean.UpdoDate} setDate={(e) => { absenteeism.setBean({ ...absenteeism.bean, "UpdoDate": e }) }} />
                                </div>

                                <div className="col-md-6">
                                    <label>Hora de Finalización</label>
                                    <div className="row">
                                        <div className="col-md-5">

                                            <select className="form-control" value={absenteeism.bean.HourUpto} onChange={(e) => { absenteeism.setBean({ ...absenteeism.bean, 'HourUpto': parseInt(e.target.value) }) }}>
                                                <option value={NaN}>...</option>
                                                <option value={0}>00</option>
                                                <option value={1}>01</option>
                                                <option value={2}>02</option>
                                                <option value={3}>03</option>
                                                <option value={4}>04</option>
                                                <option value={5}>05</option>
                                                <option value={6}>06</option>
                                                <option value={7}>07</option>
                                                <option value={8}>08</option>
                                                <option value={9}>09</option>
                                                <option value={10}>10</option>
                                                <option value={11}>11</option>
                                                <option value={12}>12</option>
                                                <option value={13}>13</option>
                                                <option value={14}>14</option>
                                                <option value={15}>15</option>
                                                <option value={16}>16</option>
                                                <option value={17}>17</option>
                                                <option value={18}>18</option>
                                                <option value={19}>19</option>
                                                <option value={20}>20</option>
                                                <option value={21}>21</option>
                                                <option value={22}>22</option>
                                                <option value={23}>23</option>

                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            :
                                        </div>
                                        <div className="col-md-5">

                                            <select className="form-control" value={absenteeism.bean.MinuteUpto} onChange={(e) => { absenteeism.setBean({ ...absenteeism.bean, 'MinuteUpto': parseInt(e.target.value) }) }}>
                                                <option value={NaN}>...</option>
                                                <option value={0}>00</option>
                                                <option value={1}>01</option>
                                                <option value={2}>02</option>
                                                <option value={3}>03</option>
                                                <option value={4}>04</option>
                                                <option value={5}>05</option>
                                                <option value={6}>06</option>
                                                <option value={7}>07</option>
                                                <option value={8}>08</option>
                                                <option value={9}>09</option>
                                                <option value={10}>10</option>
                                                <option value={11}>11</option>
                                                <option value={12}>12</option>
                                                <option value={13}>13</option>
                                                <option value={14}>14</option>
                                                <option value={15}>15</option>
                                                <option value={16}>16</option>
                                                <option value={17}>17</option>
                                                <option value={18}>18</option>
                                                <option value={19}>19</option>
                                                <option value={20}>20</option>
                                                <option value={21}>21</option>
                                                <option value={22}>22</option>
                                                <option value={23}>23</option>
                                                <option value={24}>24</option>
                                                <option value={25}>25</option>
                                                <option value={26}>26</option>
                                                <option value={27}>27</option>
                                                <option value={28}>28</option>
                                                <option value={29}>29</option>
                                                <option value={30}>30</option>
                                                <option value={31}>31</option>
                                                <option value={32}>32</option>
                                                <option value={33}>33</option>
                                                <option value={34}>34</option>
                                                <option value={35}>35</option>
                                                <option value={36}>36</option>
                                                <option value={37}>37</option>
                                                <option value={38}>38</option>
                                                <option value={39}>39</option>
                                                <option value={40}>40</option>
                                                <option value={41}>41</option>
                                                <option value={42}>42</option>
                                                <option value={43}>43</option>
                                                <option value={44}>44</option>
                                                <option value={45}>45</option>
                                                <option value={46}>46</option>
                                                <option value={47}>47</option>
                                                <option value={48}>48</option>
                                                <option value={49}>49</option>
                                                <option value={50}>50</option>
                                                <option value={51}>51</option>
                                                <option value={52}>52</option>
                                                <option value={53}>53</option>
                                                <option value={54}>54</option>
                                                <option value={55}>55</option>
                                                <option value={56}>56</option>
                                                <option value={57}>57</option>
                                                <option value={58}>58</option>
                                                <option value={59}>59</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-12">
                                    <label>Descripción del ausentismo</label>
                                    <textarea name="Descripcion" className="form-control" value={absenteeism.bean.Descripcion} onChange={absenteeism.handleChange} />
                                </div>

                            </div>

                        </>
                    </Modal>

                    <Modal modal={modalAdd} updateModal={setModalAdd} eventModal={editaItem}>
                        <>
                            <div className="col-md-12">
                                <FileInput
                                    Media={absenteeism.bean.Media}
                                    MediaContext={absenteeism.bean.MediaContext}
                                    directory='ausentes'
                                    label='Cargar un archivo'
                                    onCreate={({ MediaContext, Media }: any) => { absenteeism.setBean({ ...absenteeism.bean, "AttachFiles": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                ></FileInput>
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>

                    <Modal modal={modalCSV.modal} updateModal={modalCSV.setModal}>
                        <div className="row">
                            <div className="col">
                                {lista.length > 0 &&
                                    <ExportXLSL customName={"PersonalAusente"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                        single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}